// extracted by mini-css-extract-plugin
module.exports = {"scroll_indicator":"ScrollIndicator_scroll_indicator__Lrzqy","text":"ScrollIndicator_text__LfCYD"};